import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';


class TicketExportJobService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.TICKET_EXPORT_JOB = '/api/ticket-export-job';

        this.CREATE = '/create';
        this.GET_BY_ID = '/id/{id}';
        this.GET_RUNNING_INSTANCE_COUNT = '/get-count/{projectId}/{kaiziqResolveConnectionId}';
        this.GET_LIST_BY_PROJECT_ID_AND_CONNECTION_ID = '/list/{projectId}/{kaiziqResolveConnectionId}';
    }

    async getListByProjectIdAndConnectionId(projectId, kaiziqResolveConnectionId) {
        try {
            let url = window.location.origin + this.TICKET_EXPORT_JOB + this.GET_LIST_BY_PROJECT_ID_AND_CONNECTION_ID;
            url = url
                .replace('{projectId}', projectId)
                .replace('{kaiziqResolveConnectionId}', kaiziqResolveConnectionId);
            const ticketExportJobList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketExportJobList;
        } catch(err) {
            console.log(err);
        }
    }

    async getRunningInstanceCount(projectId, kaiziqResolveConnectionId) {
        try {
            let url = window.location.origin + this.TICKET_EXPORT_JOB + this.GET_RUNNING_INSTANCE_COUNT;
            url = url
                .replace('{projectId}', projectId)
                .replace('{kaiziqResolveConnectionId}', kaiziqResolveConnectionId);
            const getCount = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return getCount;
        } catch(err) {
            console.log(err);
        }
    }

    async getTicketExportJobById(id) {
        try {
            let url = window.location.origin + this.TICKET_EXPORT_JOB + this.GET_BY_ID;
            url = url
                .replace('{id}', id);
            const ticketExportJob = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketExportJob;
        } catch(err) {
            console.log(err);
        }
    }

    async createTicketExportJob(ticketExportJobData) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.TICKET_EXPORT_JOB + this.CREATE;
            const ticketExportJob = this.fetch(url, {
                   method:'POST',
                   headers: {
                       'Content-Type': 'application/json',
                       'X-XSRF-TOKEN': csrfToken
                   },
                   body: JSON.stringify(ticketExportJobData)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return ticketExportJob;
        } catch(err) {
            console.log(err);
        }
    }
}

export default TicketExportJobService;